import MentorList from './MentorList/index'
import MentorEdit from './MentorEdit/index'
import MentorIcon from '@material-ui/icons/DirectionsRun'

export default {
  list: MentorList,
  edit: MentorEdit,
  icon: MentorIcon,
  options: { label: 'Mentor' }
}